import React from "react";
import "./style.scss";
import SubscriptionItem from "../SubscriptionItem";

export default function SubscriptionList({ subscriptionList }) {
  return (
    <div className="subscription-list">
      {subscriptionList.map((element, index) => (
        <SubscriptionItem key={index} subscription={element} />
      ))}
    </div>
  );
}
